import styled from 'styled-components'
import { colorTheme } from '../../../../../style/theme/colorTheme'

export const OrderModalDescriptionWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 0.625em;
	padding-bottom: 1.25em;
	color: ${colorTheme.orders.modal.description.text};
	text-align: center;
`
OrderModalDescriptionWrapper.displayName = 'OrderModalDescriptionWrapper'

export const OrderModalDescriptionTitle = styled.p`
	margin: 0;
	font-size: 1.25em;
	font-weight: 700;
`
OrderModalDescriptionTitle.displayName = 'OrderModalDescriptionTitle'

export const OrderModalDescriptionText = styled.p`
	margin: 0;
	font-size: 1.125em;
	font-weight: 400;
`
OrderModalDescriptionText.displayName = 'OrderModalDescriptionText'
